// workaround for issue with user date sometimes it's number sometimes object with seconds and nanoseconds (but not firebase object cause it's missing toMillis function)
export const parseDate = (date: number | { seconds: number; nanoseconds: number }) => {
  if (typeof date === 'object' && 'seconds' in date && 'nanoseconds' in date) {
    return new Date(date.seconds * 1000 + date.nanoseconds / 1000000).getTime();
  } else {
    return date;
  }
};
